module.exports = "/img/fit-orange.png?46277e02811f56b145561d6c33226c2f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/fit-orange.png
// module id = qBLj
// module chunks = 72